import { actions } from './actions'
import { state } from './state'
import { getters } from '@/store/contractors/getters'
import { mutations } from './mutations'
import { Module } from 'vuex'

const contractorModule: Module<any, any> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}

export default contractorModule;